import { useGetCountriesQuery } from "@/redux/services/generalApi"
import type { SenderCountryCode } from "@/types/entities/sender"

export const useCountryName = (countryCode?: SenderCountryCode) => {
  const { data: countries = [] } = useGetCountriesQuery()
  const countryName =
    countries.find(({ code }) => code === countryCode)?.name ?? ""
  return countryName
}
